"use client";

import type { FC } from "react";
import { HomeAffordabilityChart } from "./charts/HomeAffordabilityChart";
import { IdleCashYieldChart } from "./charts/IdleCashYieldChart";
import { LineComparisonChart } from "./charts/LineComparisonChart";
import { RunwayBarChart } from "./charts/RunwayBarChart";
import { ResultPayoffBanner } from "./ResultPayoffBanner";
import type { ResultChartPayload } from "./types";

interface ResultChartCardProps {
  chart?: ResultChartPayload;
  payoffTitle: string;
  payoffBody: string;
  hasData: boolean;
}

const ChartVisualization: FC<{ chart: ResultChartPayload }> = ({ chart }) => {
  switch (chart.kind) {
    case "line-comparison":
      return <LineComparisonChart data={chart} />;
    case "runway-bars":
      return <RunwayBarChart data={chart} />;
    case "idle-cash-growth":
      return <IdleCashYieldChart data={chart} />;
    case "home-affordability":
      return <HomeAffordabilityChart data={chart} />;
    default:
      return null;
  }
};

export const ResultChartCard: FC<ResultChartCardProps> = ({
  chart,
  payoffTitle,
  payoffBody,
  hasData,
}) => (
  <div
    className="flex flex-col overflow-hidden rounded-xl border border-border_inverse_transparent10 bg-background_solid_neutral_primary pt-[18px]"
    data-testid="result-chart-card"
  >
    <div
      className="flex flex-col gap-3.5 px-4 pb-3.5"
      data-testid="result-chart-content"
    >
      {chart ? (
        <ChartVisualization chart={chart} />
      ) : (
        <div
          className="flex h-[120px] items-center justify-center rounded-lg bg-background_brand_overlay10"
          data-testid="result-chart-empty"
        >
          <p className="body_medium_s text-content_tertiary">
            {hasData ? "Chart data unavailable" : "No data yet"}
          </p>
        </div>
      )}
    </div>
    <ResultPayoffBanner title={payoffTitle} body={payoffBody} />
  </div>
);
